/*
 * AQS — size guide modal.
 * Delegated so it keeps working after Section Rendering API re-renders
 * (e.g. variant changes). Uses the native <dialog> element.
 */
(function () {
  if (window.__aqsSizeGuideInit) return;
  window.__aqsSizeGuideInit = true;

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-aqs-sg-open]');
    if (openTrigger) {
      event.preventDefault();
      var dialog = document.getElementById('aqs-size-guide');
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      return;
    }

    var closeTrigger = event.target.closest('[data-aqs-sg-close]');
    if (closeTrigger) {
      var parent = closeTrigger.closest('dialog');
      if (parent && typeof parent.close === 'function') parent.close();
      return;
    }

    // Click on the backdrop (the dialog element itself) closes it.
    if (
      event.target.tagName === 'DIALOG' &&
      event.target.classList.contains('aqs-sizeguide') &&
      typeof event.target.close === 'function'
    ) {
      event.target.close();
    }
  });
})();
